<template>
  <div class="full-page-width relative">
    <div class="row">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :text="$t('TXT_PAYER_INFO')"
          :title="$t('LBL_PAYERS')"
          :btnText="$t('LBL_ADD_PAYER')"
          @action="openNewPopup" />
      </div>
      <div class="col-xs-8">
        <ul class="list-table">
          <li
            class="list-table-item"
            v-for="(item, index) in get_payers.items" :key="`item-${index}`"
            @click="openEditPopup(item.id)">
            <div class="table-cell">
              <span class="main-info">
                {{ item.name }}
              </span>
              <span class="additional-info">
                 {{ get_payers.entity.type[item.type] }}
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Popup
      v-if="openPopup"
      :popupMedium=true
      :isPopupSubmitDisabled="isPopupSubmitDisabled"
      :showConfirmButton="!deletePayer"
      :showDeleteButton="deletePayer"
      @cancel="togglePopup"
      @deleteAction="deletePayerAction"
      @confirm="submitForm">
      <template v-slot:header>
        <h2 v-if="!isEdit">{{ $t('LBL_ADD_PAYER') }}</h2>
        <h2 v-if="isEdit">{{ $t('LBL_EDIT_PAYER') }}</h2>
      </template>
      <div>
        <div class="row" v-if="get_user.is_admin">
          <div class="col-xs-12">
            <InputSelect
              class="m-b-20"
              :multiSelect=true
              :preselected="form.accessible_for_subaccounts"
              :label="$t('accessible_for_accounts')"
              @change="selectAccessibleSubaccount"
              :options="getAllowedSubaccounts"
              :rules="{required: true}" />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 m-b-20">
            <InputSelect
              :label="$t('type')"
              v-model="form.type"
              :rules="{required: true}"
              :options="selectOptions(get_payers.entity['type'])" />
          </div>
          <div class="col-xs-12 m-b-20">
            <InputText
              :label="$t('name')"
              v-model="form.name"
              :rules="{required: true}" />
          </div>
        </div>
        <div class="separator medium"></div>
        <div class="row">
          <div
            style="padding: 0"
            class="col-xs-12"
            v-for="(item, index) in andConditions" :key="`and-condition-${index}`">
            <div class="col-xs-6 m-b-20">
              <InputSelect
                class="m-b-20"
                :multiSelect=false
                :label="$t('shipping_agent_name')"
                v-model="andConditions[index].shipping_agent_id"
                :options="get_company_available_shipping_agents_select.filter(item => !item.value.startsWith('ccid'))"
                :rules="{required: true}"/>
            </div>
            <div class="col-xs-5 m-b-20">
              <InputText
                v-if="getCriteriaByShippingAgent(andConditions[index].shipping_agent_id) === 'carrier_account_number'"
                :label="$t('LBL_CARRIER_ACCOUNT_NUMBER')"
                v-model="andConditions[index].criteria_value"
                :rules="{required: true}" />
              <InputSelect
                v-else
                class="m-b-20"
                :multiSelect=false
                :label="$t('agreement')"
                v-model="andConditions[index].criteria_value"
                :options="getCarrierAgreements(andConditions[index].shipping_agent_id)"
                :rules="{required: true}"/>
            </div>
            <div class="col-xs-1">
              <Btn
                style="margin-top: 25px; padding: 12px 22px; margin-left: -6px"
                @click.native="removeAndCondition(index, item)"
                class="gray"
                position="icon-pos-center"
                :icon="{
                    name: 'deleteForever',
                    size: '18',
                  }"
              />
            </div>
          </div>
          <div class="col-xs-12">
            <Btn
              @click.native="addAndCondition"
              class="brand float-left"
              :icon="{
                name: 'plus',
                size: '18',
              }"
              :btnText="$t('LBL_ADD_CARRIER')" />
          </div>
        </div>
        <div class="separator medium" v-if="isEdit"></div>
        <div class="row" v-if="isEdit">
        <div class="col-xs-12 p-b-20" >
          <div class="flex-center toggle-title">
            <div>
              <p>{{ $t('delete') }}</p>
              <span>{{ $t('TXT_PAYER_WILL_BE_DELETED') }}</span>
            </div>
            <div>
              <Toggle color="red" id="delete" v-model="deletePayer" />
            </div>
          </div>
        </div>
        </div>
      </div>
    </Popup>
  </div>
</template>
<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import mixin from '@/mixins/mixins.js';
import AddressPicker from "@/components/global/addressPicker/index.vue";
import PhoneSelect from "@/components/elements/inputs/phone.vue";
import CountryFlag from 'vue-country-flag';
import Btn from '@/components/elements/buttons';
import InputText from '@/components/elements/inputs/text.vue';
import Popup from '@/components/global/popup';
import InputSelect from '@/components/elements/inputs/select.vue';
import Toggle from '@/components/elements/inputs/toggle.vue';
import countryList from '@/data/country.js';

import InfoTextBox from '@/components/global/infoTextBox';
import formValidator from '@/mixins/formValidator';
import types from "@/store/types";

export default {
  name: 'Payers',
  mixins: [mixin, formValidator],
  components: {
    Btn,
    AddressPicker,
    PhoneSelect,
    Popup,
    InputText,
    CountryFlag,
    InputSelect,
    Toggle,
    InfoTextBox,
  },
  data() {
    return {
      openPopup: false,
      deletePayer: false,
      isEdit: false,
      andConditions: [],
      deleteOnSave: [],
      form: {
        accessible_for_subaccounts: [],
        name: '',
        type: '',
        contact_type: '',
      },
    };
  },
  computed: {
    ...mapGetters([
      'get_payers',
      'get_payer_by_id',
      'get_payer_carriers',
      'get_subaccounts',
      'get_company_available_shipping_agents_select',
      'get_integrations',
      'get_carrier_accounts_by_shipping_agent_id',
      'get_carrier_accounts',
      'get_user'
    ]),
    isPopupSubmitDisabled() {
      if(this.get_user.is_admin && this.form.accessible_for_subaccounts.length == 0) return true;

      return this.validateInput([
        {
          formField:'name',
          value: this.form.type,
          validators:{required: true}
        },
        {
          formField:'type',
          value: this.form.type,
          validators:{required: true}
        },
      ]);
    },
    getAllowedSubaccounts() {
      //return this.get_subaccounts.filter((acc) => this.get_user.accessible_subaccounts_array.indexOf(acc.id) > -1).map((acc) => ({text: acc.name, value: acc.id,}));

      return this.get_subaccounts.filter((acc) => this.get_user.accessible_subaccounts_array.indexOf(String(acc.id)) > -1).map((acc) => ({text: acc.name, value: String(acc.id)}));
    },
  },
  created() {
    this.$store.dispatch('GET_PAYERS');
    this.$store.dispatch('GET_COMPANY_AVAILABLE_SHIPPING_AGENTS');
    this.$store.dispatch('GET_CARRIER_ACCOUNTS_BY_COMPANY');
  },
  methods: {
    getCriteriaByShippingAgent(id) {
      if ([6,8,9].includes(parseInt(id))) {
        return 'carrier_account_number'
      }
      return 'agreement'
    },
    getCarrierAgreements(id) {
      const agreements = this.get_carrier_accounts_by_shipping_agent_id(id)
      const options = [];
      agreements.forEach(agreement => {
        options.push({
          text: agreement.account_name,
          value: agreement.id
        })
      })
      return options
    },
    removeAndCondition(index, item) {
      if (item.id) {
        this.deleteOnSave.push(item);
      }
      this.andConditions.splice(index, 1);
    },
    showMatchAgainstInputSelect (criteria) {
      return criteria === 'agreement';
    },
    getOperatorOptions () {
      return [
        {text: this.$t('carrier_account_number'), value: 'carrier_account_number'},
        {text: this.$t('agreement'), value: 'agreement'},
      ]
    },
    addAndCondition() {
      this.andConditions.push({
        id: null,
        shipping_agent_id: '',
        criteria_type: 'carrier_account_number',
        criteria_value: ''
      });
    },
    selectAccessibleSubaccount(val) {
        this.form.accessible_for_subaccounts = val;
    },
    selectOptions(obj) {
      const options = [];
      for (const property in obj) {
        options.push({ text: obj[property], value: parseInt(property) });
      }
      return options;
    },
    clearLocalFormData() {
      this.andConditions = [];
      this.deleteOnSave = [];
      this.form = {
        accessible_for_subaccounts: [],
        name: '',
        type: '',
      };
    },
    togglePopup() {
      this.openPopup = !this.openPopup;
      this.payerId = '';
      this.clearLocalFormData();
    },
    submitForm() {
      const action = this.isEdit ? 'EDIT_PAYER' : 'SET_PAYER';
      this.form.accessible_for_subaccounts = this.form.accessible_for_subaccounts.filter((val) => this.get_user.accessible_subaccounts_array.indexOf(val) > -1);
      this.$store.dispatch(action, {
        form: {
          accessible_for_subaccounts: this.form.accessible_for_subaccounts,
          name: this.form.name,
          type: this.form.type,
        },
        id: this.payerId || '',
      }).then((r) => {
        this.payerId = r.id
        if (this.andConditions.length > 0) {
          this.andConditions.forEach(payerCarrier => {
            payerCarrier.criteria_type = this.getCriteriaByShippingAgent(payerCarrier.shipping_agent_id)
            const payload = {
              payer_id: this.payerId,
              form: payerCarrier
            }
            if (payerCarrier.id) {
              payload['id'] = payerCarrier.id;
              this.$store.dispatch('EDIT_PAYER_CARRIER', payload)
            } else {
              this.$store.dispatch('CREATE_PAYER_CARRIER', payload)
            }
          })
        }

        if (this.deleteOnSave.length > 0) {
          this.deleteOnSave.forEach(payerCarrier => {
            this.$store.dispatch('DELETE_PAYER_CARRIERS', {
              id : payerCarrier.id,
              payer_id : this.payerId
            })
          })
        }
        this.$store.dispatch('GET_PAYERS');
        this.$store.dispatch('GET_PAYER_CARRIERS', {id : this.payerId});
        this.andConditions = this.get_payer_carriers.items
        this.openPopup = false;
        this.clearLocalFormData();
      });
    },
    deletePayerAction() {
      this.$store.dispatch('DELETE_PAYER', this.payerId).then(() => {
        this.$store.dispatch('GET_PAYERS');
        this.deletePayer = false;
        this.isEdit = false;
        this.togglePopup();
      });
    },
    openNewPopup() {
      this.deletePayer = false;
      this.isEdit = false;
      this.togglePopup();
    },
    openEditPopup(id) {
      this.deletePayer = false;
      this.togglePopup();
      this.isEdit = true;
      this.payerId = id;
      this.$store.dispatch('GET_PAYER_CARRIERS', {id}).finally(() => {
        const data = this.get_payer_by_id(id);
        this.andConditions = this.get_payer_carriers.items
       /* this.andConditions.forEach((condition, index) => {
          if (condition === 'agreement') {
            conditionthis.get_carrier_accounts_by_shipping_agent_id(condition.shipping_agent_id)
          }
        })*/
        this.form = {
          accessible_for_subaccounts: data.accessible_for_subaccounts,
          name: data.name,
          type: data.type
        };
      });
    },
  }
};
</script>
